import React from 'react';
import CopyLinkIcon from 'assets/copyLinkIcon.svg';
import CopyLinkCompletedIcon from 'assets/copyLinkCompletedIcon.svg';
import EmailIcon from 'assets/emailIcon.svg';
import FacebookIcon from 'assets/facebookIcon.svg';
import LinkedInIcon from 'assets/linkedInIcon.svg';
import TwitterIcon from 'assets/twitterIcon.svg';
import WhatsAppIcon from 'assets/whatsAppIcon.svg';
import { ShareMethodName } from './types';
import styles from 'components/ShareDialog/ShareDialog.module.scss';

function getIconComponent(
  name: ShareMethodName,
  isShareCompleted: boolean
): React.ComponentType<React.SVGProps<SVGSVGElement>> | null {
  switch (name) {
    case 'copy-link':
      return isShareCompleted ? CopyLinkCompletedIcon : CopyLinkIcon;
    case 'email':
      return EmailIcon;
    case 'facebook':
      return FacebookIcon;
    case 'linkedin':
      return LinkedInIcon;
    case 'twitter':
      return TwitterIcon;
    case 'whatsapp':
      return WhatsAppIcon;
    default:
      return null;
  }
}

interface Props {
  isShareCompleted?: boolean;
  label: string;
  name: ShareMethodName;
  onClick: React.MouseEventHandler;
}

export const ShareMethod: React.FunctionComponent<Props> = ({
  isShareCompleted = false,
  label,
  name,
  onClick,
}) => {
  const Icon = getIconComponent(name, isShareCompleted);

  return (
    <button className={styles.method} onClick={onClick}>
      <span className={styles.methodIcon} aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      {label}
    </button>
  );
};
